/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const Info16 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="currentColor"
        d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m-.553 6.187c-.748 0-1.62.313-2.315.57l-.173.641c.312-.106.656-.206.967-.206.638 0 .872.15.872.712 0 .326-.112.738-.204 1.054-.52 1.678-.811 2.376-.811 3.177q0 .642.521 1.058c1.167.934 3.19.057 3.774-.152l.172-.642c-.43.184-1.3.328-1.668.057-.374-.274-.132-1.198.001-1.617l.645-2.073a4 4 0 0 0 .164-1.104c0-.966-.824-1.475-1.945-1.475m1.647-3.812c-.777 0-1.406.572-1.406 1.278s.63 1.279 1.406 1.279S10.5 4.359 10.5 3.653s-.63-1.278-1.406-1.278"
      />
    </g>
  </svg>
);

export const Info32 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={32} height={32} viewBox="0 0 32 32" {...props}>
    <g fill="currentColor" transform="translate(11 7)">
      <path d="m8.6 16.039-.276 1.026c-.934.334-4.17 1.738-6.037.244q-.834-.666-.834-1.692c0-1.282.464-2.4 1.297-5.084.147-.506.327-1.165.327-1.687 0-.9-.375-1.14-1.395-1.14-.498 0-1.048.162-1.547.331l.276-1.026C1.523 6.601 2.92 6.1 4.115 6.1c1.793 0 3.112.813 3.112 2.36 0 .445-.085 1.226-.263 1.766l-1.031 3.317c-.213.67-.6 2.148-.002 2.587.59.432 1.982.203 2.669-.091" />
      <ellipse cx={6.75} cy={2.045} rx={2.25} ry={2.045} />
    </g>
  </svg>
);

export const __descriptor_Info = {
  name: "Info",
  instances: [
    { size: 16, Component: Info16 },
    { size: 32, Component: Info32 },
  ],
} as const;
